
import { Box, List, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { listItemTextClasses } from "@mui/material";

import { typographyClasses } from "@mui/material/Typography";
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { inherits } from "util";
//   & ${ Button }, ${ Typography } {
//     color: red;
//     font - weight: bold;
// }

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));


export const ListWrapper = styled(List)`

    background: #fff;
`
export const EventWrapper = styled(Box)(({ theme }) => ({
  marginLeft: '16px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '16px',
    marginLeft: 0,
    width: '100%'
  },
  boxShadow: '0 1px 4px rgba(0, 0, 0, .0705882353)',
  borderRadius: '5px',
  background: '#fff',
  paddingBottom: '5px',
}));

export const Title = styled(Typography)`
  padding:0px 16px;
`

export const StyledListIcon = styled(ListItemIcon)`
  margin-right:10px;
`
export const StyledBoldListItemText = styled(ListItemText)(({ theme }) => ({
  [`&&.${listItemTextClasses.root}>.${listItemTextClasses.secondary}`]: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px',
  },
  [`&&.${listItemTextClasses.root}>.${listItemTextClasses.primary}`]: {
    fontSize: '14px',
    fontWeight: 600,
  },
}));

export const StyledListItemText = styled(ListItemText)(({ theme }) => ({
  [`&&.${listItemTextClasses.root}>.${listItemTextClasses.secondary}`]: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '14px'
  },
  [`&&.${listItemTextClasses.root}>.${listItemTextClasses.primary}`]: {
    fontSize: '14px'
  },
}));
export const theme = createTheme({
  palette: {
    primary: {
      main: '#408697',
      dark: '#053e85',
    },
  },
  components: {
    MuiList: {
      styleOverrides: {
        root: {

        },
      }
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 0,
          marginTop: 0
        }
      }
    },

  }
});